import { render, staticRenderFns } from "./PaymentTypeUpdateDialog.vue?vue&type=template&id=304d0486&scoped=true"
import script from "./PaymentTypeUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./PaymentTypeUpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304d0486",
  null
  
)

export default component.exports